import { LinkText } from '@/components/atoms';
import { Constants } from '@/utils/constants/commonConstants';
import { ROUTES } from '@/utils/constants/routesConstants';

export const cellDataMapperObj = (navigate) => ({
  name: {
    cellData: ({ row: { original } = {} }) => (
      <LinkText
        text={original?.name || '—'}
        id={original?.name + ' ' + (original?.rewardId || original?.id || original?.uuid)}
        handleClick={() => {
          if (original?.rewardId || original?.id || original?.uuid) {
            navigate(`${ROUTES.REWARD_CATALOG_DETAIL.replace(':id', original?.rewardId || original?.id || original?.uuid)}?status=${original?.status}`);
          }
        }}
      />
    ),
    linkHandler: (row) => {
      if (row?.rewardId || row?.id || row?.uuid) {
        navigate(`${ROUTES.REWARD_CATALOG_DETAIL.replace(':id', row?.rewardId || row?.id || row?.uuid)}?status=${row?.status}`);
      }
    },
    linkLabel: (row) => row?.name || '—',
  },
  type: {
    cellData: ({ row: { original } = {} }) => <div>{original?.type ?? '—'}</div>,
  },
  rewardId: {
    cellData: ({ row: { original } = {} }) => <div>{original?.rewardId ?? '—'}</div>,
  },
  inventory: {
    cellData: ({row: {original} = {}}) => <div>{original?.inventory ?? '—'}</div>,
  },
  reportUrl: {
    // downloadHandler: row => onDownloadRewardCatalogReport(row.id, row.status),
    downloadLabel: original => (original?.name || '—') + ' Report',
    render: (row, column) => {
      if (row.status === Constants.Draft || row.status === Constants.Published) {
        return <div className="px-2 py-1 text-gray-500">{(row?.name || '—') + ' Report'}</div>
      }
      return (
        <LinkText
          text={column.downloadLabel(row)}
          id={row.id}
          // handleClick={() => column.downloadHandler(row)}
        />
      )
  },
},
  rewardAcceptance: {
    cellData: ({ row: { original } = {} }) => {

      const isLowAcceptance = original?.rewardAcceptance <= 75;
      return (
        <div
          className={isLowAcceptance ? 'bg-red-500 text-white' : ''}
          style={isLowAcceptance ? { fontWeight: 'bold', padding: '4px', borderRadius: '4px' } : {}}
        >
          {original?.rewardAcceptance + '%' ?? '—'}
        </div>
      );
    },
  },
  startDate: {
    cellData: ({ row: { original } = {} }) => <div>{original?.startDate ?? '—'}</div>,
  },
  endDate: {
    cellData: ({ row: { original } = {} }) => <div>{original?.endDate ?? '—'}</div>,
  },
  updatedAt: {
    cellData: ({ row: { original } = {} }) => <div>{original?.updatedAt ?? '—'}</div>,
  },
  updatedBy: {
    cellData: ({ row: { original } = {} }) => <div>{original?.updatedBy ?? '—'}</div>,
  },
  status: {
    cellData: ({ row: { original } = {} }) => <div className={original?.status === 'Error' ? 'status_error' : ''}>{original?.status ?? '—'}</div>,
  },
});
